import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\CopyPeopleFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyPeopleFromEventController.php
* @route '/api/planning/{event}/copy-people'
*/
const CopyPeopleFromEventController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyPeopleFromEventController.url(args, options),
    method: 'post',
})

CopyPeopleFromEventController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}/copy-people',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\CopyPeopleFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyPeopleFromEventController.php
* @route '/api/planning/{event}/copy-people'
*/
CopyPeopleFromEventController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return CopyPeopleFromEventController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\CopyPeopleFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyPeopleFromEventController.php
* @route '/api/planning/{event}/copy-people'
*/
CopyPeopleFromEventController.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyPeopleFromEventController.url(args, options),
    method: 'post',
})

export default CopyPeopleFromEventController